<template>
  <footer class="text-gray-600 body-font">
    <div class="px-4 pt-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
      <div class="grid gap-16 row-gap-10 mb-8 lg:grid-cols-6">
        <div class="md:max-w-md lg:col-span-2">
          <a href="/" title="Bouquet" class="inline-flex items-center">
            <span class="text-xl font-bold tracking-wide text-gray-800 uppercase">Bouquet</span>
          </a>
          <div class="mt-4 lg:max-w-sm">
            <p class="text-sm text-gray-800">
              {{ $t('footer.about-us') }}
            </p>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-5 row-gap-8 lg:col-span-4 md:grid-cols-4">
          <div></div>
          <div></div>
          <div>
            <p class="font-semibold tracking-wide text-gray-800">{{ $t('footer.info') }}</p>
            <ul class="mt-4 space-y-4">
              <li>
                <a href="/terms" class="text-gray-600 transition-colors duration-300 hover:text-gray-800">
                  {{ $t('footer.terms') }}
                </a>
              </li>
              <li>
                <a href="/policy" class="text-gray-600 transition-colors duration-300 hover:text-gray-800">
                  {{ $t('footer.policy') }}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p class="font-semibold tracking-wide text-gray-800">{{ $t('footer.contact') }}</p>
            <ul class="mt-4 space-y-4">
              <li>
                <a href="/faq" class="text-gray-600 transition-colors duration-300 hover:text-gray-800">
                  {{ $t('footer.faq') }}
                </a>
              </li>
              <li>
                <a href="/contact" class="text-gray-600 transition-colors duration-300 hover:text-gray-800">
                  {{ $t('footer.contact') }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-100">
      <div class="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
        <p class="text-gray-500 text-sm text-center sm:text-left">© 2016-2023 Bouquet.ee — {{ $t('footer.made-with') }} <span
            style="color: #e25555;">&#9829;</span> {{ $t('footer.in-estonia') }}
        </p>
        <span class="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
          <a href="https://www.facebook.com/bouquet.ee" class="text-gray-500">
            <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5"
                 viewBox="0 0 24 24">
              <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
            </svg>
          </a>
          <a href="mailto:hello@bouquet.ee" class="ml-3 text-gray-500">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                 class="w-5 h-5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/bouquet.ee" class="ml-3 text-gray-500">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                 class="w-5 h-5" viewBox="0 0 24 24">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
            </svg>
          </a>
          <a class="ml-4 text-gray-500 text-sm text-center items-center" href="tel:+37255907056">
             +372 55 90 70 56
          </a>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
